function enhanceModalButtons(modal) {
  const buyButtons = modal.querySelectorAll('button[type="submit"], .shopify-payment-button__button, [data-testid="buy-buttons"] button, .product-form__buttons button');
  
  buyButtons.forEach(button => {
    if (!button.closest('.glassmorphism-button-wrap') && 
        !button.classList.contains('glassmorphism-button')) {
      
      const wrapper = document.createElement('div');
      wrapper.className = 'glassmorphism-button-wrap';
      
      const shadow = document.createElement('div');
      shadow.className = 'glassmorphism-button-shadow';
      
      button.parentNode.insertBefore(wrapper, button);
      wrapper.appendChild(shadow);
      wrapper.appendChild(button);
      
      button.classList.add('glassmorphism-button');
      
      const existingSpan = button.querySelector('span');
      if (!existingSpan) {
        const textSpan = document.createElement('span');
        textSpan.textContent = button.textContent;
        button.textContent = '';
        button.appendChild(textSpan);
      }
    }
  });
}

function setupModalObserver() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.tagName === 'QUICK-BUY-MODAL' || node.querySelector('quick-buy-modal')) {
              const modals = node.tagName === 'QUICK-BUY-MODAL' ? [node] : node.querySelectorAll('quick-buy-modal');
              modals.forEach(modal => {
                setTimeout(() => enhanceModalButtons(modal), 100);
              });
            }
            
            const modals = node.querySelectorAll('quick-buy-modal');
            modals.forEach(modal => {
              setTimeout(() => enhanceModalButtons(modal), 100);
            });
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function enhanceTrackingButtons(trackingApp) {
  const trackingButtons = trackingApp.querySelectorAll('.pp-button-enter, .pp_enter_submit, .pp_tracking_button button, .onst-custom-form-submit');
  
  trackingButtons.forEach(button => {
    if (!button.closest('.glassmorphism-button-wrap') && 
        !button.classList.contains('glassmorphism-button')) {
      
      const wrapper = document.createElement('div');
      wrapper.className = 'glassmorphism-button-wrap';
      
      const shadow = document.createElement('div');
      shadow.className = 'glassmorphism-button-shadow';
      
      button.parentNode.insertBefore(wrapper, button);
      wrapper.appendChild(shadow);
      wrapper.appendChild(button);
      
      button.classList.add('glassmorphism-button');
      
      const existingSpan = button.querySelector('span');
      if (!existingSpan) {
        const textSpan = document.createElement('span');
        textSpan.textContent = button.textContent;
        button.textContent = '';
        button.appendChild(textSpan);
      }
    }
  });
}

function enhanceB2BFormButtons() {
  const b2bForm = document.querySelector('.onst-registration-form, .SureCust-App');
  if (b2bForm) {
    const b2bButtons = b2bForm.querySelectorAll('.onst-custom-form-submit');
    
    b2bButtons.forEach(button => {
      if (!button.closest('.glassmorphism-button-wrap') && 
          !button.classList.contains('glassmorphism-button')) {
        
        const wrapper = document.createElement('div');
        wrapper.className = 'glassmorphism-button-wrap';
        
        const shadow = document.createElement('div');
        shadow.className = 'glassmorphism-button-shadow';
        
        button.parentNode.insertBefore(wrapper, button);
        wrapper.appendChild(shadow);
        wrapper.appendChild(button);
        
        button.classList.add('glassmorphism-button');
        
        button.style.cssText = `
          background-color: transparent !important;
          background: linear-gradient(-75deg, #ffffff0d, #fff3, #ffffff0d) !important;
          border-color: rgba(255, 255, 255, 0.2) !important;
          border: 1px solid rgba(255, 255, 255, 0.2) !important;
          box-shadow: inset 0 .125em .125em #0000000d, inset 0 -.125em .125em #ffffff80, 0 .25em .125em -.125em #0003, 0 0 .1em .25em inset #fff3 !important;
          backdrop-filter: blur(clamp(1px, .125em, 4px)) !important;
          -webkit-backdrop-filter: blur(clamp(1px,.125em,4px)) !important;
          border-radius: 999vw !important;
          color: rgba(0, 0, 0, 1) !important;
          font-size: 14px !important;
          height: 40px !important;
          padding-inline: 1.2em !important;
          padding-block: 0 !important;
        `;
        
        const existingSpan = button.querySelector('span');
        if (!existingSpan) {
          const textSpan = document.createElement('span');
          textSpan.textContent = button.textContent;
          button.textContent = '';
          button.appendChild(textSpan);
        }
      }
    });
  }
}

function addSectionWhiteClass() {
  const trackingApp = document.getElementById('pp-tracking-page-app');
  if (trackingApp) {
    trackingApp.classList.add('section-white');
    const firstChild = trackingApp.firstElementChild;
    if (firstChild) {
      firstChild.classList.add('section-white');
    }
    
    enhanceTrackingButtons(trackingApp);
    
    if (window.checkHeaderPositionWithTracking) {
      window.checkHeaderPositionWithTracking();
    }
  }
}

function addFrcpSectionClasses() {
  const frcpApp = document.querySelector('.frcp-app');
  if (frcpApp) {
    frcpApp.classList.add('section-white', 'custom-header-spacing');
    
    if (window.checkHeaderPositionWithFrcp) {
      window.checkHeaderPositionWithFrcp();
    }
  }
  
  const mainElement = document.querySelector('main.anchor.frcp-app-parent');
  if (mainElement) {
    mainElement.classList.add('section-white');
    
    if (window.checkHeaderPositionWithFrcp) {
      window.checkHeaderPositionWithFrcp();
    }
  }
}

function startTrackingPolling() {
  let attempts = 0;
  const maxAttempts = 50;
  
  const pollForTracking = () => {
    attempts++;
    addSectionWhiteClass();
    addFrcpSectionClasses();
    enhanceB2BFormButtons();
    
    if (attempts < maxAttempts) {
      setTimeout(pollForTracking, 200);
    }
  };
  
  pollForTracking();
}

document.addEventListener('DOMContentLoaded', () => {
  setupModalObserver();
  startTrackingPolling();
});

document.addEventListener('shopify:section:load', () => {
  setupModalObserver();
  startTrackingPolling();
});

window.addEventListener('load', () => {
  setupModalObserver();
  startTrackingPolling();
});

document.addEventListener('click', (event) => {
  const target = event.target.closest('button[aria-controls*="modal"], a[aria-controls*="modal"]');
  if (target) {
    const modalId = target.getAttribute('aria-controls');
    setTimeout(() => {
      const modal = document.getElementById(modalId);
      if (modal && modal.tagName === 'QUICK-BUY-MODAL') {
        enhanceModalButtons(modal);
      }
    }, 500);
  }
});
